import { render, staticRenderFns } from "./MultiTaskContainer.vue?vue&type=template&id=b974bafc&"
import script from "./MultiTaskContainer.vue?vue&type=script&lang=js&"
export * from "./MultiTaskContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports